import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import backgroundImage from "assets/images/bg-profile.jpeg";
import { Avatar } from "@mui/material";
import { useStoreState } from "easy-peasy";
import nameInitials from "name-initials";
import { CheckPermissionRender } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import MDButton from "../../components/MDButton";
import { useState } from "react";
import ChangePassword from "./change_password";

export default function SimpleHeader() {
  const authUser = useStoreState((state) => state.authUser);

  const [state, setState] = useState({
    openChangePassword: false,
  });
  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}
      >
        <Grid container alignItems="center" justifyContent={"space-between"} gap={2}>
          <Grid item alignItems="center">
            <Grid container spacing={3}>
              <Grid item>
                <Avatar color="red" sx={{ width: 56, height: 56, bgcolor: "#1A73E8" }}>
                  {nameInitials(authUser.name)}
                </Avatar>
              </Grid>
              <Grid item>
                <MDBox height="100%" mt={0.5} lineHeight={1}>
                  <MDTypography variant="h5" fontWeight="medium">
                    {authUser.name}
                  </MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    {authUser.user_name}
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <CheckPermissionRender permissions={permissions().profile().update().list()}>
              <MDButton
                onClick={() => {
                  setState({ ...state, openChangePassword: true });
                }}
                variant="gradient"
                color="dark"
              >
                change password
              </MDButton>
            </CheckPermissionRender>
          </Grid>
        </Grid>
      </Card>
      <CheckPermissionRender permissions={permissions().profile().update().list()}>
        <ChangePassword
          open={state.openChangePassword}
          onClose={() => {
            setState({ ...state, openChangePassword: false });
          }}
        />
      </CheckPermissionRender>
    </MDBox>
  );
}
